import React, { useState } from 'react'
import date from 'date-and-time'
import Button from '../../../Components/Buttons/Button'
import Modal from '../../../Components/Modal/Modal'
import Reschedule from '../../../App/Course/Components/Dashboard/Components/GroupCourseDashboard/Components/BatchTimings/Components/Reschedule'
import { classReschedule } from '../../../API/Course'

const Header = ({
  enrollment,
  endsOn,
  remaining,
  toggleRescheduleAll,
  userType,
}) => {
  const [open, showModal] = useState(false)
  const [rescheduleData, setRescheduleData] = useState(null)

  return (
    <div className='timingsHeader'>
      {userType === 'teacher' && (
        <Button
          name='Create Make Up Class'
          onClick={() => {
            setRescheduleData({ extraClass: true })
            showModal(true)
          }}
          type='primary'
        />
      )}
      {userType === 'teacher' && Boolean(remaining) && (
        <Button
          type={'secondary'}
          name={`Reschedule remaining ${remaining} classes`}
          onClick={toggleRescheduleAll}
        />
      )}
      {endsOn && <p>Ends on {date.format(new Date(endsOn), 'DD MMMM YYYY')}</p>}
      {open && (
        <Modal close={() => showModal(false)}>
          <Reschedule
            data={rescheduleData}
            onSubmit={async (data) => {
              console.log({ enrollment, data })
              const success = await classReschedule({
                startTime: data.startTime,
                crId: enrollment.id,
                extraClass: true,
              })

              if (success) {
                window.location.reload()
              }

              showModal(false)
            }}
          />
        </Modal>
      )}
    </div>
  )
}

export default Header
